import React, { useEffect, useRef, useState } from "react";
import downChevron from "../../../../../assets/icons/down-chevron.svg";
import searchIcon from "../../../../../assets/icons/search.svg";

// Styles
import "./SearchDropdownType.scss";

const tempSelectTag = {
  optionValue: "Select a tag name",
};

const SearchDropdownType = ({
  field,
  viewOnly,
  showInDocUpload,
  dropdownValueChangeHandler,
  handleAddNewTag,
  userRole,
}) => {
  const [searchString, setSearchString] = useState("");
  const [selectedTag, setSelectedTag] = useState({ optionValue: field.fieldValue });
  const [isSeachDropdownOpen, setIsSeachDropdownOpen] = useState(false);

  const dropdownRef = useRef();

  const handleClickOutsideOfDropdown = (event) => {
    if (dropdownRef && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsSeachDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideOfDropdown);

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideOfDropdown);
    };
  }, []);

  const searchedTags =
    searchString === ""
      ? field.options
      : field.options.filter((tag) => tag.optionValue.toLowerCase().includes(searchString.toLowerCase()));

  const handleSelectTag = (tag) => {
    setSelectedTag(tag);
    setIsSeachDropdownOpen(false);
    const e = {
      target: {
        id: field.fieldId,
        value: tag.optionValue,
      },
    };
    dropdownValueChangeHandler(e);
  };

  const handleToggle = () => {
    setIsSeachDropdownOpen((isSeachDropdownOpen) => !isSeachDropdownOpen);
  };

  useEffect(() => {
    if (isSeachDropdownOpen) {
      if (dropdownRef) {
        dropdownRef.current.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
      }
    }
  }, [isSeachDropdownOpen]);

  let className = "form-group pt-6 pl-3";
  if (showInDocUpload) {
    className = "form-group pt-3 ";
  }
  if (viewOnly) {
    className += " view-only row";
  }

  const handleClearSelection = () => {
    handleSelectTag(tempSelectTag);
  };

  useEffect(() => {
    setSelectedTag({ optionValue: field.fieldValue });
  }, [field.fieldValue]);

  return (
    <div className={`item-selector-container ${className}`}>
      <div className={`title ${viewOnly ? "col-md-4 col-sm-6" : ""}`}>
        <label
          className={[viewOnly ? "" : "bold", field.fieldLabel.length > 12 && viewOnly ? "hide-text" : ""].join(" ")}
          htmlFor={field.fieldId}
        >
          {field.fieldLabel}
          {field.fieldRequired && !viewOnly && "*"}
        </label>
        {!viewOnly && selectedTag.optionValue !== tempSelectTag.optionValue ? (
          <span className="clear-button link" onClick={handleClearSelection}>
            Clear
          </span>
        ) : null}
      </div>
      {viewOnly ? (
        <span className="item-name-view-only">{field.fieldValue === tempSelectTag.optionValue ? "-" : field.fieldValue}</span>
      ) : (
        <div ref={dropdownRef}>
          <div className="selection-box" onClick={handleToggle}>
            <span>
              {selectedTag.optionValue === tempSelectTag.optionValue ? tempSelectTag.optionValue : field.fieldValue}
            </span>
            <img src={downChevron} alt="Select tag" />
          </div>

          {isSeachDropdownOpen ? (
            <div className="item-dropdown">
              <div className="search-box">
                <img src={searchIcon} alt="Search tag" />
                <input
                  type="text"
                  value={searchString}
                  onChange={(e) => setSearchString(e.target.value)}
                  placeholder="Search"
                />
              </div>
              <div className="item-dropdown-options">
                {searchedTags.map((searchedTag) => (
                  <div
                    className={`item-dropdown-options-row ${
                      selectedTag && selectedTag.optionValue === searchedTag.optionValue ? "selected" : ""
                    } `}
                    key={searchedTag.optionId ?? Math.random()}
                    onClick={() => handleSelectTag(searchedTag)}
                  >
                    <div className="item-name">{searchedTag.optionValue}</div>
                    <div className="category-name">{searchedTag.optionCategory}</div>
                  </div>
                ))}
                {(searchString.trim().length !== 0 || field.options.length === 0) &&
                (userRole === 1 || userRole === 2) ? (
                  <div className="item-dropdown-options-row-add " onClick={handleAddNewTag}>
                    ＋ Add new tag
                  </div>
                ) : field.options.length === 0 ? (
                  <div className="item-dropdown-options-row no-result">No tags available!</div>
                ) : searchedTags.length === 0 ? (
                  <div className="item-dropdown-options-row no-result">No results found!</div>
                ) : null}
              </div>
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default SearchDropdownType;
